module.exports = {
  "/": {
    "name": "storefront-all-categories",
    "success": {
      "storefront page loaded": [
        "STOREFRONT_LOAD"
      ]
    },
    "error": [
      "STOREFRONT_ERROR_LOAD"
    ]
  },
  "/featured": {
    "name": "storefront-featured-apps",
    "success": {
      "storefront page loaded": [
        "FEATURED_APPS_LOAD"
      ]
    },
    "error": [
      "STOREFRONT_ERROR_LOAD"
    ]
  },
  "/page/:page": {
    "name": "storefront-all-categories-page",
    "success": {
      "storefront page loaded": [
        "STOREFRONT_LOAD"
      ]
    },
    "error": [
      "STOREFRONT_ERROR_LOAD"
    ]
  },
  "/:categoryOrSlug": {
    "name": "storefront-category-or-detail",
    "success": {
      "detail not found error state": [
        "DETAIL_NOT_FOUND_ERROR_LOAD"
      ],
      "detail page loaded": [
        "DETAIL_HEADER_LOAD"
      ],
      "storefront page loaded": [
        "STOREFRONT_LOAD"
      ],
      "not found error loaded": [
        "NOT_FOUND_ERROR_LOAD"
      ]
    },
    "error": [
      "STOREFRONT_ERROR_LOAD",
      "COLLECTION_ERROR_LOAD",
      "DETAIL_ERROR_LOAD"
    ]
  },
  "/:category/page/:page": {
    "name": "storefront-category-page",
    "success": {
      "storefront page loaded": [
        "STOREFRONT_LOAD"
      ],
      "not found error loaded": [
        "NOT_FOUND_ERROR_LOAD"
      ]
    },
    "error": [
      "STOREFRONT_ERROR_LOAD",
      "COLLECTION_ERROR_LOAD"
    ]
  },
  "/:slug/reviews": {
    "name": "detail-reviews",
    "success": {
      "detail reviews loaded": [
        "DETAIL_REVIEWS_LOAD"
      ]
    }
  },
  "/:slug/write-review": {
    "name": "detail-write-review",
    "success": {
      "detail page loaded": [
        "DETAIL_HEADER_LOAD"
      ]
    }
  }
};